'use client';

import { c as _c } from "react/compiler-runtime";
import * as Headless from '@headlessui/react';
import { cn } from '@/frontend/utils';
import { colors } from './switchStyles';
export type SwitchColor = keyof typeof colors;
export interface SwitchProps extends Omit<Headless.SwitchProps, 'as' | 'className' | 'children'> {
  color?: SwitchColor;
  className?: string;
}
export function Switch(t0) {
  const $ = _c(11);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      color: t1,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const color = t1 === undefined ? "algoprimary" : t1;
  const t2 = colors[color];
  let t3;
  if ($[4] !== className || $[5] !== t2) {
    t3 = cn("group relative isolate inline-flex h-6 w-10 cursor-default rounded-full p-[3px] sm:h-5 sm:w-8", "transition duration-0 ease-in-out data-changing:duration-200", "forced-colors:outline forced-colors:[--switch-bg:Highlight] dark:forced-colors:[--switch-bg:Highlight]", "bg-backgroundTertiary ring-1 ring-borderSupport ring-inset", "data-checked:bg-(--switch-bg) data-checked:ring-(--switch-bg-ring)", "focus:outline-hidden data-focus:outline-2 data-focus:outline-blue-500 data-focus:outline-offset-2", "data-disabled:opacity-50", t2, className);
    $[4] = className;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span aria-hidden="true" className={cn("pointer-events-none relative inline-block size-[1.125rem] rounded-full sm:size-3.5", "translate-x-0 transition duration-200 ease-in-out", "bg-white shadow-xs ring-1 ring-borderSupport", "data-checked:ring-borderInversePrimary group-data-checked:ring-borderInverseTertiary", "group-data-checked:translate-x-4 sm:group-data-checked:translate-x-3", "group-data-checked:group-data-disabled:bg-white group-data-checked:group-data-disabled:shadow-xs group-data-checked:group-data-disabled:ring-black/5")} />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== props || $[9] !== t3) {
    t5 = <Headless.Switch data-slot="control" {...props} className={t3}>{t4}</Headless.Switch>;
    $[8] = props;
    $[9] = t3;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}